module.exports = __webpack_public_path__ + "static/media/generatingPreview.daebc356.png";